import { cartDetailsFragment } from '../queries/get-cart-query'

const cartLineItemRemove = `
  mutation cartLinesRemove(
    $cartId: ID!
    $lineItemIds: [ID!]!
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineItemIds) {
      userErrors {
        code
        field
        message
      }
      cart {
        ...cartDetails
      }
    }
  }

  ${cartDetailsFragment}
`

export default cartLineItemRemove
